// icons
import { MdViewKanban } from "react-icons/md";

const tasksBoard = {
  id: 'tasks-board-group',
  type: 'group',
  roles: [1],
  breadcrumbs: false,
  children: [
    {
      id: 'tasks-board',
      title: "Tasks board",
      type: 'item',
      breadcrumbs: false,
      icon: MdViewKanban,
      url: '/tasks-board'
    }
  ]
};

export default tasksBoard;
